export default {"src":"/_next/static/media/arrow-down-heavy.160ceb72.svg","height":13,"width":12,"blurWidth":0,"blurHeight":0};